import { Box } from '@material-ui/core';
import { experimentalStyled as styled } from '@material-ui/core/styles';

const badgeBaseStyles = {
  zIndex: 100,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #7cff6b 0%, #39FF14 50%, #1bc400 100%)',
  color: '#043e00',
  fontWeight: 800,
  textTransform: 'uppercase',
  borderRadius: '4px',
  lineHeight: 1.2,
  flexShrink: 0,
  boxShadow: '0 3px 12px rgba(57, 255, 20, 0.45), inset 0 1px 0 rgba(255,255,255,0.4)',
  textShadow: '0 1px 1px rgba(255,255,255,0.5)',
  animation: 'salesOrderNewBadgePulse 2.2s ease-in-out infinite',
  '@keyframes salesOrderNewBadgePulse': {
    '0%, 100%': {
      boxShadow: '0 3px 12px rgba(57, 255, 20, 0.45), inset 0 1px 0 rgba(255,255,255,0.4)',
    },
    '50%': {
      boxShadow: '0 3px 18px rgba(57, 255, 20, 0.85), inset 0 1px 0 rgba(255,255,255,0.55)',
    },
  },
};

export const SalesOrderNewBadge = styled(Box)({
  position: 'absolute',
  top: '-8px',
  right: '-8px',
  padding: '4px 10px',
  fontSize: '10px',
  letterSpacing: '1.8px',
  ...badgeBaseStyles,
});

export const SalesOrderNewBadgeList = styled(Box)({
  position: 'relative',
  padding: '2px 6px',
  fontSize: '9px',
  letterSpacing: '1.2px',
  ...badgeBaseStyles,
});

export const getSalesOrderNewRowSx = (theme, isNew) => {
  if (!isNew) return {};
  const isLight = theme.palette.mode === 'light';
  return {
    borderLeft: isLight ? '3px solid rgba(40, 220, 10, 0.95)' : '3px solid rgba(57, 255, 20, 0.75)',
    backgroundColor: isLight ? 'rgba(40, 220, 10, 0.06)' : 'rgba(57, 255, 20, 0.08)',
    boxShadow: isLight ? 'inset 0 0 12px rgba(40, 220, 10, 0.12)' : 'inset 0 0 10px rgba(57, 255, 20, 0.1)',
  };
};

export const getSalesOrderNewCardSx = (theme, isNew) => {
  if (!isNew) return {};
  const isLight = theme.palette.mode === 'light';
  return {
    border: isLight ? '2.5px solid rgba(40, 220, 10, 0.95)' : '1.5px solid rgba(57, 255, 20, 0.75)',
    boxShadow: isLight ? '0 0 20px rgba(40, 220, 10, 0.7)' : '0 0 15px rgba(57, 255, 20, 0.45)',
    overflow: 'visible',
    animation: 'salesOrderCardPulse 2.2s ease-in-out infinite',
    '@keyframes salesOrderCardPulse': {
      '0%, 100%': {
        boxShadow: isLight ? '0 0 15px rgba(40, 220, 10, 0.6)' : '0 0 12px rgba(57, 255, 20, 0.45)',
        borderColor: isLight ? 'rgba(40, 220, 10, 0.85)' : 'rgba(57, 255, 20, 0.65)',
      },
      '50%': {
        boxShadow: isLight ? '0 0 35px rgba(40, 220, 10, 0.95)' : '0 0 25px rgba(57, 255, 20, 0.85)',
        borderColor: isLight ? 'rgba(40, 220, 10, 1)' : 'rgba(57, 255, 20, 1)',
      },
    },
  };
};
